module.exports = __webpack_public_path__ + "static/media/icon-alert.28e1778f.svg";